import { render } from "./ChatMessageSources.vue?vue&type=template&id=5fd78d39&scoped=true"
import script from "./ChatMessageSources.vue?vue&type=script&lang=js"
export * from "./ChatMessageSources.vue?vue&type=script&lang=js"

import "./ChatMessageSources.vue?vue&type=style&index=0&id=5fd78d39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd78d39"]])

export default __exports__